import { useState } from "react";
import { Grid, IconButton, TextField, Tooltip, Typography } from "@material-ui/core";
import { Refresh } from "@material-ui/icons";

import ListTable from "./ListTable";
import { getFiscalYearRange, getFiscalYearLabel } from "../../../utils/fiscalYear";

function TimeResearch() {
  // Mặc định theo NĂM TÀI CHÍNH (01/04 – 31/03), không phải năm dương lịch.
  // Xem utils/fiscalYear.js. Người dùng vẫn sửa tay được 2 ô ngày.
  const defaultRange = getFiscalYearRange();
  const [startDate, setStartDate] = useState(defaultRange.startDate);
  const [endDate, setEndDate] = useState(defaultRange.endDate);
  const [reloadKey, setReloadKey] = useState(0);

  const handleReload = () => {
    setReloadKey((prev) => prev + 1);
  };

  return (
    <Grid
      container
      spacing={2}
      style={{
        overflow: "auto",
        maxHeight: "calc(100vh - 164px)",
        width: "calc(100% + 16px)",
      }}
    >
      <Grid item xs={3}>
        <TextField
          label="Từ ngày"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          label="Đến ngày"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          variant="outlined"
          size="small"
          fullWidth
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
      <Grid item xs={3} style={{ display: "flex", alignItems: "center" }}>
        <Tooltip title="Tải lại dữ liệu">
          <IconButton color="primary" onClick={handleReload} size="small">
            <Refresh />
          </IconButton>
        </Tooltip>
        <Typography variant="caption" color="textSecondary" style={{ marginLeft: 8 }}>
          Năm tài chính {getFiscalYearLabel()}
        </Typography>
      </Grid>
      <ListTable startDate={startDate} endDate={endDate} key={reloadKey} />
    </Grid>
  );
}

export default TimeResearch;
